import axios from 'axios'

const kratosClient = axios.create({
  baseURL: '/api/kratos',
  withCredentials: true,
  headers: {
    Accept: 'application/json',
  },
})

export default kratosClient